module.exports = __webpack_public_path__ + "img/background_main_game.4aa24109.svg";